import { Component, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ApiService } from 'src/app/_services/api.service';
import { GlobalService } from 'src/app/_services/global.service';
import { SortService, SelectionService, RowDDService, GridComponent, ToolbarService, SearchService, ToolbarItems, FilterService } from '@syncfusion/ej2-angular-grids';
import  itlocale  from './../../../../itgridlocale.json';
import { L10n } from '@syncfusion/ej2-base';
import { ConfirmationService, MenuItem, MessageService } from 'primeng/api';
import { forkJoin } from 'rxjs';
import { v4 as uuidv4 } from 'uuid';
import { environment } from 'src/environments/environment';


L10n.load(itlocale);

@Component({
  selector: 'app-playlist-edit',
  templateUrl: './playlist-edit.component.html',
  styleUrls: ['./playlist-edit.component.css'],
  providers: [ SortService,SelectionService,MessageService,ConfirmationService],
  encapsulation: ViewEncapsulation.None
})
export class PlaylistEditComponent implements OnInit {
  @ViewChild('fornituregrid') fornituregrid:any;

  files = [];
  showDialogNodo:boolean=false;
  wtList:any[]=[];
  moviesList:any[]=[];
  currentMRSteps:any;
  related_playlist_id:number=0;
  elencoPlayList:any[]=[];
  urlvideo='';
  nomevideo='';
  pl:any={
    nome:'',
    descrizione:'',
    docfiles:[],
    urlfiles:[],
  };
  
  action='';
  
  uploadurl='';

  
  constructor(
    private apiService: ApiService,
    public globalService : GlobalService,
    private messageService: MessageService,
    private route: ActivatedRoute,
    public router: Router,
    public confirmationService: ConfirmationService
  ) { }


  ngOnInit(): void {
    
    this.action=this.route.snapshot.paramMap.get('action');
    this.apiService.post('kodi/playlistslistall',{}).subscribe(data2 => {
      this.elencoPlayList=[];
      this.elencoPlayList.push({
          id:0,
          nome:'nessuna playlist'
      });
      data2.Result.forEach((p)=>{
        this.elencoPlayList.push({
            id:p.id,
            nome:p.nome
        });
      });
    });

    this.uploadurl= environment.API_URL+'kodi/uploadmovie/0';
    if(this.route.snapshot.paramMap.get('id')){
      this.uploadurl= environment.API_URL+'kodi/uploadmovie/'+this.route.snapshot.paramMap.get('id');
      this.apiService.post('kodi/movie_listall',{id:this.route.snapshot.paramMap.get('id')}).subscribe((data2:any) => {
        this.moviesList=data2.Result;
      });
      this.apiService.post('kodi/playlistslistall',{id:this.route.snapshot.paramMap.get('id')}).subscribe((data2:any) => {
        this.pl=data2.Result[0];
        this.pl.docfiles=[];
        this.pl.urlfiles=[];
        
      });

    } 

  }

   onSelectedFiles(event) {
      this.files = event.currentFiles;
   }

  salva(){
    this.apiService.post('kodi/updateplaylist',this.pl).subscribe(data => {
        this.addSingle('success', 'Success', 'Playlist salvata');
        setTimeout(()=>{
          window.location.reload();
        },2000);
      });
  }
   
  delete(){
      this.confirmationService.confirm({
        message: 'Attenzione: si conferma la cancellazione?',
        accept: () => {
          this.apiService.post('kodi/deleteplaylist',this.pl).subscribe(data => {
          this.addSingle('success', 'Success', 'Playlist cancellata');
          setTimeout( ()=>{
            this.router.navigateByUrl('/dashboard/monitors/playlists');
          },1500);
        });
      }
    });
  }
  
  onUpload(event){
    this.pl.docfiles=event.originalEvent.body.Result;
    this.addSingle('success', 'Success', 'Document uploaded');
  }
  
  addSingle(sev: string, sum: string, det: string) {
    this.messageService.add({severity: sev, summary: sum, detail: det});
  }

  savedisabled(){
    if(this.pl.name==''){
      return true;
    } 
    return false;
  }

  collegaPlaylist(){
    if(this.route.snapshot.paramMap.get('id')==''+this.related_playlist_id){
      return;
    }
    this.pl.urlfiles.push({
      related_playlist_id:this.related_playlist_id,
      percorso:'PlayList',
      nome:''
    })
  
    this.apiService.post('kodi/updateplaylist',this.pl).subscribe(data => {
      this.addSingle('success', 'Success', 'Playlist caricata');
      setTimeout(()=>{
        window.location.reload();
      },2000);
    });
  }
  

  caricavideo(){
    this.pl.urlfiles.push({
      nome:this.nomevideo,
      percorso:this.urlvideo
    })
    this.apiService.post('kodi/updateplaylist',this.pl).subscribe(data => {
      this.addSingle('success', 'Success', 'Video caricato');
      setTimeout(()=>{
        window.location.reload();
      },2000);
    });
  }
  cancella(data){
    this.apiService.post('kodi/deletemovie',data).subscribe(data => {
      this.addSingle('success', 'Success', 'Video cancellato');
      setTimeout(()=>{
        window.location.reload();
      },2000);
    });
  }
}


